import React, { Component } from 'react';
import style from './EmailVerification.module.css';

import Lottie from 'lottie-react';
import check_animation from '../../lottieAnimations/checkmark.json';
import warning_animation from '../../lottieAnimations/warning_animation.json';
import verification_animation from '../../lottieAnimations/verification_animation.json';
import icons from '../../icons';
import { AppContext } from '../../AppContext';

import { db, auth } from '../../firebase';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from 'firebase/firestore';
import Banner from '../Banner/Banner';
import urls from '../../urls';


export default class EmailVerification extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            userData: undefined,
            error: undefined,
            loading: false,
            newPassword: undefined,
            passwordError: { hideError: true, error: undefined },
        };

        this.logout = async () => {
            fetch(urls.unsubscribe, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ userId: this.context.user?.id }),
            });
    
            console.log("Logout");
            localStorage.removeItem("userData");
            localStorage.removeItem("loggedInClassroom");
            await signOut(auth);

            window.location.reload();
        }
    };

    async componentDidMount() {
        onAuthStateChanged(auth, async user => {
            if (!user)
                return;

            this.setState({ userData: (await getDoc(doc(db, "users", user.uid))).data() });
        });
    }

    render() {
        if (!auth.currentUser)
            return (
                <main className={ style.main }>
                    <Lottie 
                        style={{ backgroundColor: "rgb(44, 44, 44)" }}                        
                        loop={ false }
                        autoplay={ true }
                        animationData={ warning_animation }
                        speed={ 0.1 }
                        delay={ 5000 }
                        height={ 300 }
                        width={ 300 }
                    />
                    <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Effettua prima il login!</h3>
                    <div className={ [style.button, style.orangeBackground].join(" ") } style={{ marginTop: "1rem" }} onClick={ () => this.context.setPage({ page: "login" }) } >
                        <img alt="" src={ icons.login_icon } />
                        <h3>VAI AL LOGIN</h3>
                    </div> 
                </main>
            );

        if (auth.currentUser?.emailVerified && !this.state.userData?.updatingEmail)
            return <>
                <Banner />
                <main className={ style.main }>
                    <Lottie 
                        style={{ backgroundColor: "rgb(44, 44, 44)" }}
                        loop={ false }
                        autoplay={ true }
                        animationData={ check_animation }
                        speed={ 0.1 }
                        delay={ 5000 }
                        height={ 300 }
                        width={ 300 }
                    />
                    <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Email verificata!</h3>
                    <div className={ [style.button, style.orangeBackground].join(" ") } onClick={ () => this.context.setPage({ page: "home" }) } >
                        <img alt="" src={ icons.home_icon } />
                        <h3>VAI ALLA HOME</h3>
                    </div> 
                    <div className={ [style.button, style.orangeBackground].join(" ") } style={{ marginTop: "1rem" }} onClick={ this.logout } >
                        <img alt="" src={ icons.login_icon } />
                        <h3>TORNA AL LOGIN</h3>
                    </div> 
                </main>
            </>;

        return <>
            <Banner />
            <main className={ [style.main, style.emailVerification].join(" ") }>
                <Lottie 
                    style={{ marginTop: "3rem" }}                    
                    loop={ false }
                    autoplay={ true }
                    animationData={ verification_animation }
                    height={ 300 }
                    width={ 300 }
                />
                <h3 style={{ textAlign: "center", fontSize: "1.8rem", color: "var(--orange)", marginTop: "4rem", lineHeight: "2rem" }}>Controlla anche la casella SPAM</h3>
                <h3 style={{ textAlign: "center", fontSize: "1rem" }}>Verifica il tuo account dall'email che ti abbiamo inviato!</h3>
                { auth.currentUser?.email?.includes("@gmail.com") && <div className={ style.button } onClick={ () => window.open("https://mail.google.com/mail/#inbox") }>
                    <img alt="" src={ icons.mail_icon } />
                    <h3>VAI ALLA TUA MAIL</h3>
                </div> }
                <div className={ [style.button, style.orangeBackground].join(" ") } style={{ marginTop: "1rem" }} onClick={ this.logout } >
                    <img alt="" src={ icons.login_icon } />
                    <h3>TORNA AL LOGIN</h3>
                </div> 
                {/* <div className={ style.button } style={{ background: "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" }} onClick={ async () => {
                    await signOut(auth);
                    this.props.setPage({ page: "login" });
                } }>
                    <img alt="" src={ icons.logout_icon } />
                    <h3>TORNA AL LOGIN</h3>
                </div> */}
            </main>
        </>;
    };
};
